var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfraid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_163)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18_163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 34.9999C27.1649 34.9999 34.9999 27.1649 34.9999 17.5C34.9999 7.835 27.1649 0 17.5 0C7.835 0 0 7.835 0 17.5C0 27.1649 7.835 34.9999 17.5 34.9999Z",
    fill: "#BC8ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 32.4165C11.5851 32.4165 3.7501 24.5815 3.7501 14.9166C3.7501 9.75296 5.98695 5.11241 9.54401 1.90918C3.87855 4.80596 0 10.7 0 17.5C0 27.1649 7.83496 34.9999 17.4999 34.9999C22.0013 34.9999 26.1051 33.2998 29.2059 30.5075C26.8189 31.7279 24.115 32.4165 21.25 32.4165Z",
    fill: "#976198"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4076 25.7493C24.7935 25.8261 25.0741 25.2117 24.7935 24.7893C23.6358 22.9462 21.8817 21.7559 19.882 21.7559C17.9175 21.7559 16.1283 22.9462 15.0057 24.7893C14.7601 25.2117 15.0057 25.8261 15.3916 25.7493C16.7247 25.4421 18.2683 25.2885 19.882 25.2885C21.5309 25.2501 23.0394 25.4421 24.4076 25.7493Z",
    fill: "#862D98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1025 11.0204C10.8696 11.0162 10.6533 10.9861 10.461 10.9292C10.1291 10.8309 9.9396 10.482 10.0379 10.15C10.1362 9.81805 10.4853 9.62854 10.817 9.72686C11.1241 9.81794 11.7584 9.76932 12.4837 9.45587C13.1936 9.1493 13.6798 8.70608 13.8467 8.40299C14.0137 8.0996 14.3948 7.98906 14.6982 8.15611C15.0015 8.3231 15.112 8.70439 14.945 9.0076C14.6054 9.62451 13.8711 10.2223 12.9809 10.6069C12.3301 10.888 11.6676 11.0305 11.1025 11.0204Z",
    fill: "#862D98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7503 11.2265C27.185 11.2163 26.5283 11.0501 25.8879 10.7457C25.0121 10.3295 24.2999 9.70558 23.9827 9.07692C23.8267 8.7679 23.9509 8.39083 24.2601 8.23486C24.5692 8.07864 24.9462 8.20313 25.1021 8.51221C25.2581 8.8211 25.7279 9.28141 26.4263 9.61331C27.1399 9.95259 27.7723 10.024 28.0821 9.94413C28.4178 9.85811 28.7592 10.0596 28.8455 10.395C28.9318 10.7302 28.73 11.0721 28.3947 11.1584C28.2005 11.2084 27.9832 11.2307 27.7503 11.2265Z",
    fill: "#862D98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4121 16.3535C15.4843 16.3535 16.3535 15.4843 16.3535 14.4121C16.3535 13.3399 15.4843 12.4707 14.4121 12.4707C13.3399 12.4707 12.4707 13.3399 12.4707 14.4121C12.4707 15.4843 13.3399 16.3535 14.4121 16.3535Z",
    fill: "#862D98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2568 16.3535C26.329 16.3535 27.1982 15.4843 27.1982 14.4121C27.1982 13.3399 26.329 12.4707 25.2568 12.4707C24.1846 12.4707 23.3154 13.3399 23.3154 14.4121C23.3154 15.4843 24.1846 16.3535 25.2568 16.3535Z",
    fill: "#862D98"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfraid);
export default __webpack_public_path__ + "static/media/Afraid.14366546af17aa882284dc6d1b17163e.svg";
export { ForwardRef as ReactComponent };